import EN from "@keita/lanepatrol-sdk/locals/en.json";
const NAMESPACE = "sdk";

export { EN, NAMESPACE };
